<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Discharge Port Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Discharge Port</label>
                <input type="text" class="form-control" id="name" v-model="dp.name">
                <!-- <input type="text" class="form-control" v-model="mm.module" id="module" aria-describedby="module"> -->
                <!-- <select type = "dropdown" class="form-control" id="module" v-model="mm.module">
                    <option v-for="(list, index) in this.moduleLists" :key="index" :value="list.value">{{ list.title }}</option>
                </select> -->
            </div>
        </div>
        <div class="row">
          <app-lookup-field :model="dp" :element="countryLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../services/api'
import { dischargePort } from '../models/dischargePort'
import AppLookupField from '../components/AppLookupField.vue'
import AppDatePicker from '../components/AppDatePicker.vue'
import AppNavBar from '../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
        return {
            dp: {...dischargePort},
            countryLookup: {
                id: 'country',
                title: 'Country',
                type: 'form',
                apiUrl: 'country-list',
                filter: ['name'],
                fields: [
                    {
                    placeholder: 'Country',
                    width: 4,
                    column: 'countryName'
                    }
                ],
                dtElements: [
                    {
                    title: 'Nama',
                    column: 'name'
                    },
                ],
                affectedField: [
                {
                    from: 'id',
                    to: 'countryId'
                },
                {
                    from: 'name',
                    to: 'countryName'
                }
                ]
            },
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const dpApi = api('discharge-port')
            this.dp = await dpApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const dpApi = api('discharge-port')
            if(this.$route.query.id !== undefined) {
                await dpApi.update(this.dp, this.$route.query.id)
            } else {
                await dpApi.create(this.dp)
                
            }
            this.$router.go(-1)
        },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentDp = this.dp
            this.dp = {
                ...currentDp,
                ...data
            }
        }
    }
}
</script>